// Canonical screen-reader label for a symbol.
// Reading order: name → Unicode codepoint → character.
// Sentences are separated by periods so screen readers pause naturally.
// Example: "Black Star. Unicode U+2605. Character ★."
export function symbolAriaLabel(opts: {
  name: string;
  code: string;
  symbol: string;
}): string {
  const { name, code, symbol } = opts;
  return `${name}. Unicode ${code}. Character ${symbol}.`;
}

// Variant for copy buttons — same order, prefixed with the action.
export function copySymbolAriaLabel(opts: {
  name: string;
  code: string;
  symbol: string;
}): string {
  const { name, code, symbol } = opts;
  return `Copy ${name}. Unicode ${code}. Character ${symbol}.`;
}
